import { FC, useMemo } from 'react';
import dayjs from 'dayjs';
import { ProDatePicker } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { DEFAULT_DATA_FORMAT, TABLE_COLUMN_EMPTY } from '../constants/constant';
import { DatePickerProps } from 'antd/lib/date-picker';
import { FormInstance } from 'antd/lib/form';

interface FormDatePickerProps extends Omit<DatePickerProps, 'onChange'> {
  onChange?: (date: dayjs.Dayjs, dateString: string | string[], record?: any, form?: FormInstance<any>) => void;
};
export interface SimpleFormDatePickerProps extends BaseSimpleFormProps {
  datePickerProps?: FormDatePickerProps;
}
const simpleFormDatePicker: FC<SimpleFormDatePickerProps> = props => {
  const { disabledRender, datePickerProps = {}, form, initialValue, ...restProps } = props;
  const { onChange, ...restDatePicker } = datePickerProps;
  const handleRender = (val: any) => {
    if (disabledRender) return disabledRender;
    if (dayjs.isDayjs(val)) {
      // @ts-ignore
      return val.format(datePickerProps?.format || DEFAULT_DATA_FORMAT);
    }
    return TABLE_COLUMN_EMPTY;
  };
  const initDayValue = useMemo(() => {
    if (!initialValue || dayjs.isDayjs(initialValue)) return initialValue;
    return dayjs(initialValue);
  }, [initialValue]);
  const handleChange = (date: dayjs.Dayjs, dateString: string | string[]) => {
    onChange?.(date, dateString, form?.getFieldsValue(true), form);
  };
  return (
    <SimpleFormItem {...restProps} initialValue={initDayValue}>
      {datePickerProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          render={handleRender}
        />
      ) : (
        <ProDatePicker
          style={DEFAULT_STYLE}
          format={DEFAULT_DATA_FORMAT}
          onChange={handleChange}
          {...restDatePicker}
        />
      )}
    </SimpleFormItem>
  );
};

simpleFormDatePicker.displayName = SimpleFormItemEnum.SimpleFormDatePicker;

export default simpleFormDatePicker;
